function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m0 0h24v24h-24z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m10.314997 14.1097181-3.10191769-.0150391c-.14580656-.0010433-.28962115-.0339596-.42136544-.0964422-.49900706-.2366652-.71167717-.8330454-.475012-1.3320524l4.78752513-10.09446718c.0995136-.20982395.2689515-.37847202.4792381-.47700427.5001074-.23433112 1.0954874-.01887692 1.3298186.48123043l4.7618949 10.16279272c.0632461.1349793.0955164.2823905.0944499.4314488-.0039515.5522706-.4548585.9967711-1.0071292.9928196l-3.1442014-.0153416v7.5319189c0 .5515432-.4454773.9970205-.9970206.9970205h-1.3092597c-.5515433 0-.9970206-.4454773-.9970206-.9970205z",
  transform: "matrix(.93969262 -.34202014 .34202014 .93969262 -3.496571 4.846563)"
});

function SvgIcSelectBlack24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSelectBlack24Px);
export default __webpack_public_path__ + "static/media/ic_select_black_24px.3aa6dc12.svg";
export { ForwardRef as ReactComponent };